import React from "react";
import { useSelector } from "react-redux";
import { selectDarkMode } from "../../../app/store/slices/uiSlice";
import Cloud from "../../../assets/images/cloud.png";
import userInterface from "../../../assets/images/user_interface.png";
import line from "../../../assets/images/Isolation_Mode.png";

const Modal = ({ isOpen, onClose, title, showTitle = true, children, size = "default", showCloseButton = true, className = "", contentClass = "", titleClass = "" }) => {
  const darkMode = useSelector(selectDarkMode);

  if (!isOpen) return null;

  const sizeClasses = {
    sm: "max-w-md",
    default: "max-w-lg",
    lg: "max-w-4xl",
    xl: "max-w-6xl",
  };

  return (
    <div className="modal-backdrop z-50 !mt-0" onClick={onClose}>
      <div className="modal-container overflow-x-hidden">
        <div className={`modal-content overflow-hidden p-0 ${sizeClasses[size]} w-full ${darkMode ? "bg-gray-800 border border-gray-700" : "bg-white"} ${className}`} onClick={(e) => e.stopPropagation()}>
          {/* Header */}
          <div className={`modal_header relative bg-[linear-gradient(180deg,#4A9CFF_0%,#4057FE_100%)] ${showTitle ? "h-[124px]" : "h-[160px]"}`}>
            {!showTitle && <h3 className="w-full text-2xl font-bold text-white text-center relative z-30 absolute top-[50px]">{title}</h3>}
            {showTitle && <img src={userInterface} alt="user" className="text-center m-auto pt-12 z-10 relative" />}
            <img src={line} alt="line" className="absolute top-0 left-0 w-full" />
            <img src={Cloud} alt="cloudIcon" className={`absolute left-0 w-full z-20 ${showTitle ? "top-[60px]" : "top-[90px]"}`} />
          </div>

          {/* Content */}
          <div className={`modal_bottom_content z-50 relative -mt-4 p-4 ${darkMode ? "bg-gray-800" : "bg-white"} ${contentClass}`}>
            {showTitle && <h3 className={`text-2xl font-bold text-center ${darkMode ? "text-white" : "text-[#232526]"} ${titleClass}`}>{title}</h3>}
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
